export default () => ({
  container: {
    padding: '3em 0',
  },
});
